<span *ngIf="tracking" class="track-container">
   <ng-container *ngIf="project === 'customer-portal' && acl === 'both'">
      <ng-container *ngIf="currentTrack === 'ship'">
         <button mat-button [matMenuTriggerFor]="hawb" class="common-mr2ex">
            HAWB<mat-icon>arrow_drop_down</mat-icon>
         </button>
         <mat-menu class="float-menu" #hawb="matMenu" xPosition="before" overlapTrigger="false">
            <button mat-menu-item (click)="currentTrack = 'quote'; placeholder = 'Enter A Quote'">
               <mat-icon>request_quote</mat-icon>
               Quote
            </button>
         </mat-menu>
      </ng-container>

      <ng-container *ngIf="currentTrack === 'quote'">
         <button mat-button [matMenuTriggerFor]="quote" class="common-mr2ex">
            Quote<mat-icon>arrow_drop_down</mat-icon>
         </button>
         <mat-menu class="float-menu" #quote="matMenu" xPosition="before" overlapTrigger="false">
            <button mat-menu-item (click)="currentTrack = 'ship'; placeholder = 'Enter A HAWB'">
               <mat-icon [svgIcon]="'shipments'"></mat-icon>
               HAWB
            </button>
         </mat-menu>
      </ng-container>
   </ng-container>
   <mat-form-field floatLabel="never">
      <span matPrefix class="common-mr2ex" *ngIf="project === 'none'" >
         <mat-icon svgIcon="track"></mat-icon>
      </span>
      <input matInput #trackInput [placeholder]="placeholder" [(ngModel)]="track_value" (keyup.enter)="track()" (keyup.esc)="tracking = false" />
      <button mat-button matSuffix (click)="track()">Go</button>
   </mat-form-field>

   <button mat-icon-button (click)="closeTracking()" class="common-ml1em">
      <mat-icon>chevron_left</mat-icon>
   </button>
</span>

<ng-container *ngIf="show && !tracking">
   <ng-container *ngIf="trackItem as item">
      <button [id]="( item.label | camelcase ) + 'Menu'" mat-button class="nav-item" (click)="tracking = true;" [matTooltip]="!showLabel ? item.label : ''">
         <mat-icon [id]="( item.label | camelcase ) + 'Icon'" [svgIcon]="item.icon"></mat-icon>
         <span *ngIf="showLabel">
            {{item.label | uppercase}}
         </span>
      </button>
   </ng-container>
</ng-container>
